// 간단한 로딩 스피너 — lucide-react Loader2 아이콘 사용.
import { Loader2 } from 'lucide-react';

export function Spinner({ label }: { label?: string }) {
  return (
    <div className="spinner" role="status" aria-live="polite">
      {/* animate-spin 클래스로 회전 애니메이션 적용 */}
      <Loader2 className="spinner__icon animate-spin" size={20} aria-hidden />
      {label && <span className="spinner__label">{label}</span>}
    </div>
  );
}
